import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "transaction-item" };
const _hoisted_2 = { class: "transaction-row" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "transaction-details" };
const _hoisted_5 = { class: "transaction-info" };
const _hoisted_6 = { class: "merchant-info" };
const _hoisted_7 = { class: "merchant-name" };
const _hoisted_8 = { class: "amount-row" };
const _hoisted_9 = { class: "face-value" };
const _hoisted_10 = { class: "percentage" };
const _hoisted_11 = { class: "cashback-badge" };
const _hoisted_12 = ["src"];
const _hoisted_13 = { class: "cashback-amount" };
const _hoisted_14 = {
    key: 0,
    class: "redeemed-row"
};
const _hoisted_15 = { class: "redeemed-label" };
const _hoisted_16 = ["src"];
const _hoisted_17 = { class: "redeemed-amount" };
import { ref, computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecentDiscountTransactionItem',
    props: {
        merchantName: {},
        icon: {},
        faceValue: {},
        savedToSpendEarningsAmount: {},
        savingPercentage: {},
        usedSavedToSpend: {},
        formatter: {}
    },
    setup(__props) {
        const props = __props;
        const imageError = ref(false);
        const defaultFormatter = { format: (v) => '£' + v.toFixed(2) };
        const formattedFaceValue = computed(() => {
            return (props.formatter || defaultFormatter).format(props.faceValue);
        });
        const formattedCashback = computed(() => {
            return (props.formatter || defaultFormatter).format(props.savedToSpendEarningsAmount);
        });
        const formattedPercentage = computed(() => {
            return props.savingPercentage.toFixed(1);
        });
        const formattedRedeemed = computed(() => {
            return (props.formatter || defaultFormatter).format(props.usedSavedToSpend);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                        src: _ctx.icon,
                        alt: _ctx.merchantName,
                        class: "merchant-icon",
                        onError: _cache[0] || (_cache[0] = ($event) => (imageError.value = true))
                    }, null, 40, _hoisted_3),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.merchantName), 1),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(formattedFaceValue.value), 1),
                                    _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(formattedPercentage.value) + "%)", 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("img", {
                                    src: require('@/assets/icons/coins-swap.png'),
                                    alt: "cashback",
                                    class: "cashback-icon"
                                }, null, 8, _hoisted_12),
                                _createElementVNode("span", _hoisted_13, "+" + _toDisplayString(formattedCashback.value), 1)
                            ])
                        ])
                    ])
                ]),
                (_ctx.usedSavedToSpend)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("img", {
                                src: require('@/assets/icons/coins-swap.png'),
                                alt: "redeemed",
                                class: "redeemed-icon"
                            }, null, 8, _hoisted_16),
                            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Redeemed", -1))
                        ]),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(formattedRedeemed.value), 1)
                    ]))
                    : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "divider" }, null, -1))
            ]));
        };
    }
});
